<template>
  <div id="date-picker-social">
    <div class="block">
      <el-date-picker
          size="mini"
          :picker-options="pickerOptions"
          v-if="isDatePickerVisible"
          ref="picker"
          :disabled="isDisabled"
          type="datetime"
          :clearable="false"
          format="dd/MM/yyyy HH:mm"
          :value="datePost"
          v-model="localDate"
          @blur="updateDatePicker"
          @change="validateDateTime($event)"
          placeholder="Selectionnez date et horaire">
      </el-date-picker>
    </div>
    <div class="message-publish" v-if="statusPost === 'no planned' && !isCurrentlyPublished && possedeNetwork">
      <em class="el-icon-close"></em>
      {{$t("general.calendar.postNoPlanned")}}
    </div>
    <div class="message-publish" v-if="statusPost === 'published' && !isCurrentlyPublished">
      <em class="el-icon-check"></em>
      {{$t("general.calendar.postPublished")}}
    </div>
    <div class="message-publish" v-if="statusPost === 'planned'">
      <em class="el-icon-timer"></em>
      {{$t("general.calendar.postPlanned")}}
    </div>
    <div class="message-publish" v-if="statusPost === 'isCurrentlyPublished' || isCurrentlyPublished">
      <em class="el-icon-check"></em>
      {{$t("general.calendar.postAlreadyPlanned")}}
    </div>
  </div>
</template>
<script>

export default {
  name: 'DatePickerPost.vue',
  props: ['datePost', 'statusPost', 'isDatePickerVisible', 'getDatePost', 'getStatusPost', 'isCurrentlyPublished', 'possedeNetwork', 'editSchedule'],
  data () {
    return {
      today: Date.now()
    }
  },
  methods: {
    updateDatePicker () {
      this.$emit('lostFocusDatePicker', false)
    },
    // Function pour valider
    validateDateTime (dateTime) {
      this.$emit('validateDateTime', [dateTime, 'planned'])
    }
  },
  computed: {
    pickerOptions () {
      return {
        disabledDate (time) {
          const date = new Date()
          const yesterday = date.setDate(date.getDate() - 1)
          return time.getTime() < yesterday
        },
        selectableRange: '06:00:00 - 23:59:59'
      }
    },
    isDisabled () {
      if (this.editSchedule) {
        return false
      } else {
        return this.statusPost && this.statusPost !== 'no planned'
      }
    },
    localDate:
    {
      get () {
        return this.datePost
      },
      set (val) {
        this.$emit('update:datePost', val)
      }
    },
    mounted () {
      this.getDatePost()
      this.getStatusPost()
    }
  }
}
</script>

<style scoped>
.message-publish{
    margin-top: 10px;
}
.el-icon-close{
  color: #D3495B;
  margin-right: 5px;
  font-weight: bold;
}
.el-icon-check{
  color: #90D2D9;
  margin-right: 5px;
  font-weight: bold;
}
.el-icon-timer{
  color: #50B2C0;
  margin-right: 5px;
  font-weight: bold;
}

</style>
